<template>
  <div id='mainView'>
    <Banner
      imageSmall="https://trustcircle-images.s3.ap-south-1.amazonaws.com/landings/trustcircle-scarf-school-screening-small.jpg"
      imageLarge="https://trustcircle-images.s3.ap-south-1.amazonaws.com/landings/trustcircle-scarf-school-screening.jpg"
      paddingBottom="50.5%"
      title="Wellbeing Assessments for Schools/Colleges"
      desc="Stay happy and emotionally resilient with early health checkup in schools and colleges"
      />
    <section class='hero is-small'>
      <div class='hero-body'>
        <div class='container features'>
          <h2 class='is-size-5'>
            The session has the following steps:
            <br>
            <ol class="is-offset-1 is-size-6">
              <li>Enter Access Code</li>
              <li>Read the general information</li>
              <li>Attend the well-being assessments</li>
              <li>Check your results</li>
            </ol>
          </h2>
        </div>
        <br>
        <div class="has-text-centered">
          <input type="text" class="input is-large" placeholder="Organization Code" v-model='orgCode'>
          <p class="is-danger help">{{error.orgCode}}</p>
          <br>
          <button class="button is-large" :class='{"is-loading": isLoading}' @click="next()">Enter</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Banner from './Banner';

export default {
  name: 'mainView',
  components: {
    Banner,
  },
  data() {
    return {
      orgCode: '',
      isLoading: false,
      error: {
        orgCode: this.msgOrgCode,
      },
    };
  },
  methods: {
    isOrgCodeValid() {
      if (this.$helpers.isOrgCode(this.orgCode)) {
        this.error.orgCode = '';
        return true;
      }
      this.error.orgCode = this.msgOrgCode;
      return false;
    },
    next() {
      if (!this.isOrgCodeValid()) {
        return;
      }
      this.isLoading = true;
      this.$http.post('/scarf/createSession', {
        orgCode: this.orgCode,
      })
        .then((res) => {
          this.isLoading = false;
          if (res.data.ok === 1) {
            console.log('scarf session id:', res.data.sessionCode);
            this.$temp.sessionCode = res.data.sessionCode;
            this.$toast.open('Your session is created');
            this.$router.push('language-selection');
          } else {
            this.$toast.open(res.data.msg);
          }
        });
    },
  },
  watch: {
    orgCode(val) {
      if (this.$helpers.isOrgCode(val)) {
        this.error.orgCode = '';
        return;
      }
      this.error.orgCode = this.msgOrgCode;
    },
  },
  computed: {
    msgOrgCode() {
      return 'Enter valid access code';
    },
  },
};
</script>

<style scoped>
.hero {
  background: linear-gradient(to right, #E1BEE7 0%, #FFFFFF 100%);
}

.title {
  color: #01579B;
  font-weight: 500;
}

.subtitle {
  font-size: 1.4rem;
}

ol {
  margin-left: 1em;
}

.is-large {
  width: 100%;
  border-radius: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Main.vue